import { useEffect, useRef, useState } from "react";

import { useModal } from "../../../providers/ModalProvider/ModalProvider";

import { capitalizeString } from "../../../utilities/helpers";

import Modal from "react-bootstrap/Modal";
import CloseButton from "react-bootstrap/CloseButton";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Badge from "react-bootstrap/Badge";
import Stack from "react-bootstrap/Stack";

import { WarningCard } from "../../WarningCard";

export default function ViewVouchers({ vouchers, onClose }) {
  const { closeModal } = useModal();

  const getStatus = (claimed) => {
    if (claimed) return "redeemed";
    return "active";
  };

  const getColor = (claimed) => {
    if (claimed) return "redeemed";
    return "active";
  };

  const handleClose = () => {
    if (onClose) onClose();
    closeModal();
  };

  return (
    <>
      <Modal.Header className="border-0 pb-0 mb-4">
        <Modal.Title className="h4 text-dark">View Vouchers</Modal.Title>
        <CloseButton onClick={handleClose} />
      </Modal.Header>
      <div className="header pt-0 mb-4">
        <WarningCard
          text="You can redeem vouchers for a ticket at the Box Office for any
                      available game"
          variant="primary"
          iconStyle="info"
          marginValue="0"
        />
      </div>
      <Modal.Body className="pb-0">
        {vouchers && vouchers?.length > 0 ? (
          <Stack gap={2} as="ul">
            {vouchers.map((voucher, idx) => (
              <Card as="li" key={idx} body className="card-list">
                <div className="card-body-heading--flex card-body-heading--flex-space-between flex-grow-1 m-0">
                  <Card.Title as="h5" className="card-title-sm">
                    {voucher?.code}
                  </Card.Title>
                  <Badge
                    bg="none"
                    className={`badge--${getColor(voucher?.claimed)}`}
                  >
                    {capitalizeString(getStatus(voucher?.claimed))}
                  </Badge>
                </div>
              </Card>
            ))}
          </Stack>
        ) : (
          <div className="text-center py-5">
            <h5 className="text-muted">No vouchers found</h5>
            <p className="text-muted mb-0">
              This order doesn't have any associated vouchers.
            </p>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer className="border-0 btn-group-flex">
        <Button variant="primary" onClick={handleClose} className="w-100">
          Close
        </Button>
      </Modal.Footer>
    </>
  );
}
